import React from "react";
import ConfirmModal from "components/ConfirmModal";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { rulesSetStore } from "../RulesSetStore";
import { useLocation, useNavigate } from "react-router";
import { MEStore } from "features/MappingEditor/MappingEditorStore";
import { buildingStore } from "store/Building/BuildingStore";
import { ROUTES_ENUM } from "routes/consts";

const NoRulesPopup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const openRulesEditor = () => {
    MEStore.setSelectedRows([]);
    MEStore.setSelectAllChecked(false);
    navigate(
      `/${buildingStore.currentBuilding?.organisation_id}/${ROUTES_ENUM.RULES_EDITOR}`,
      {
        replace: true,
        state: location.pathname,
      }
    );
  };

  return (
    <ConfirmModal
      close={() => rulesSetStore.setOpenNoRulePopup(false)}
      open={rulesSetStore.openNoRulePopup}
      confirmButtonTitle={t("rulesEditor.createRule")}
      descriptionMesage={t("rulesEditor.noRulesDescription")}
      title={t("rulesEditor.noRulesTitle")}
      type="info"
      onConfirm={openRulesEditor}
      containerClassName="!min-w-[640px]"
    />
  );
};

export default observer(NoRulesPopup);
